export namespace Config {
    export const DNS_IP_SERVER = '34.200.20.188';
    export const IPIFY_API_URL = 'https://api.ipify.org?format=json';
    export const DEFAULT_RECURRENCY_TYPE: "month" | "year" = "month";
}
